import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "external-assessment(/:curriculumProgramId)",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "external-assessment-setup" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
